/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rapporten_Config_Elements_Fietsvaardigheid_VoorkantInputs */

const nl_rapporten_config_elements_fietsvaardigheid_voorkant = /** @type {(inputs: Rapporten_Config_Elements_Fietsvaardigheid_VoorkantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fietsvaardigheid`)
};

/**

* @param {Rapporten_Config_Elements_Fietsvaardigheid_VoorkantInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const rapporten_config_elements_fietsvaardigheid_voorkant = /** @type {((inputs?: Rapporten_Config_Elements_Fietsvaardigheid_VoorkantInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rapporten_Config_Elements_Fietsvaardigheid_VoorkantInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_rapporten_config_elements_fietsvaardigheid_voorkant(inputs)
});
export { rapporten_config_elements_fietsvaardigheid_voorkant as "rapporten.config.elements.fietsvaardigheid_voorkant" }